module.exports = __webpack_public_path__ + "img/John_deere.a72c7945.png";